import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { WebClient } from '@injectables';
import { Client, User } from '@models';
import { DialogService } from '../dialog.service';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { RestTypes } from '@lib/model-meta';
import { RestModel } from '@lib/web-client/rest-model';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
    selector: 'dialog-add-text-column-options',
    templateUrl: './dialog-add-text-column-options.component.html',
    styleUrls: ['./dialog-add-text-column-options.component.scss']
})

export class DialogAddTextColumnOptionsComponent {
    public selectedClient: Client | null = null;
    public benchSeamArray: (number | string)[] = [];
    public restClient: RestModel<Client, RestTypes>;
    public loading = false;
    public newValue: string | number | null = null;
    public hasInteracted = false;

    constructor(
        private readonly fragQuery: FragQueryService,
        private readonly webClient: WebClient,
        public readonly user: User,
        private readonly host: MatDialogRef<boolean>,
        protected readonly dialog: DialogService,
    ) {
        this.restClient = this.webClient.model.client;
    }

    ngOnInit() {
        this.loadClientData();
    }

    private loadClientData() {
        this.loading = true;

        this.fragQuery.client$.subscribe((client) => {
            if (!client) return this.resetLoading();
            this.selectedClient = client;
            this.benchSeamArray = !client.benchSeam?.trim() ? [] : client.benchSeam.split(',')
                .map(val => val)
            if (this.benchSeamArray.length > 0) {
                this.hasInteracted = true;
            }
            this.loading = false;
        });
    }

    public cancel(): void {
        this.host.close(false);
    }

    public async save(): Promise<void> {
        
        if (this.newValue && this.newValue.toString().trim() !== "" && !this.benchSeamArray.includes(this.newValue)) {
            this.benchSeamArray.push(this.newValue);
        }

        if (!this.selectedClient) return;

        const updatedClient = { ...this.selectedClient };
        let benchValues = this.benchSeamArray

        updatedClient['benchSeam'] = benchValues.join(',');

        try {
            await this.dialog.await(this.restClient.save(updatedClient));
            this.fragQuery.trigger$.next();
            this.host.close(true);
        } catch (error) {
            console.error('Save failed', error);
        }
    }

    public removeValue(value: number | string): void {
        this.benchSeamArray = this.benchSeamArray.filter(v => v !== value);
        if (this.benchSeamArray.length === 0 && this.hasInteracted) {
            return;
        }
    }

    public valid(): boolean {
        return this.hasInteracted || this.benchSeamArray.length > 0 || (this.newValue !== null && this.newValue.toString().trim()!=="");
    }

    public addValue(event: MatChipInputEvent): void {
        const rawValue = event.value.trim();
        if (!rawValue) {
            return;
        }

        if (!this.benchSeamArray.includes(rawValue)) {
            this.benchSeamArray.push(rawValue);
            this.hasInteracted = true;
        }
        this.newValue = null
        event.chipInput?.clear();
    }

    private resetLoading(): void {
        this.selectedClient = null;
        this.benchSeamArray = [];
        this.loading = false;
    }
}
